import { useCallback, useEffect, useState } from "react";
import { doc, increment, onSnapshot, setDoc } from "firebase/firestore";

import { db } from "../firebase";

export const STATS_DEFAULTS = {
  noneShared: 0,
  color: 0,
  shape: 0,
  shading: 0,
  number: 0,
  totalSets: 0,
  gamesFinished: 0,
  gamesQuit: 0,
  setsAtQuit: 0,
};

// Live all-time stats for the signed-in user, synced through Firestore.
// Offline reads come from the local cache and writes queue until reconnect.
function useAllTimeStats(user) {
  const uid = user ? user.uid : null;
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!db || !uid) {
      setStats(null);
      return;
    }
    return onSnapshot(
      doc(db, "stats", uid),
      (snap) => setStats({ ...STATS_DEFAULTS, ...snap.data() }),
      (error) => console.warn("Failed to load all-time stats", error)
    );
  }, [uid]);

  const recordStats = useCallback(
    (increments) => {
      if (!db || !uid) return;
      const updates = {};
      for (const key of Object.keys(increments)) {
        updates[key] = increment(increments[key]);
      }
      // Fire-and-forget so gameplay never blocks on the network
      setDoc(doc(db, "stats", uid), updates, { merge: true }).catch((error) => {
        console.warn("Failed to record stats", error);
      });
    },
    [uid]
  );

  return [stats, recordStats];
}

export default useAllTimeStats;
